var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupIconPreRequisite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6269",
    "data-name": "Group 6269",
    transform: "translate(16883 19802)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1260",
    "data-name": "Rectangle 1260",
    width: 24,
    height: 24,
    transform: "translate(-16883 -19802)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M21,11V3H13l3.29,3.29-10,10L3,13v8h8L7.71,17.71l10-10Z",
    transform: "translate(-16883 -19802)",
    fill: "#1648c6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIconPreRequisite);
export default __webpack_public_path__ + "static/media/GroupIconPreRequisite.5e3d06c92b8d66ceb7fb4a33569c1026.svg";
export { ForwardRef as ReactComponent };